/**
 * 買取伝票 (AP_Order_Head) を削除する batch SQL を作る。
 *
 * ヘッダーだけを `DELETE VERTEX <rid>` で消すと、明細 (AP_Order_Line) が孤児として残り、
 * 存在しない伝票の RID を指し続ける。DB の移行などで RID が詰め直されると、その RID を
 * 新しい伝票が取った時に古い明細が新しい伝票に付いてしまう (2026-10 伝票 92054 ほか)。
 * そのため明細・署名画像・ヘッダーを 1 トランザクションでまとめて削除する。
 * どれかが失敗すればすべて取り消される。
 *
 * @param rid  伝票ヘッダーの @rid (例: '#507:1482')
 * @param uuid 伝票の uuid (署名画像 AP_Image の紐付けキー)
 */
export function buildRemoveOrderSql(rid: string, uuid: string): string {
    if (!/^#\d+:\d+$/.test(String(rid))) {
        throw new Error('invalid order rid: ' + rid);
    }
    const id = String(uuid || '').replace(/[^0-9A-Za-z-]/g, '');
    let sql = 'BEGIN\n';
    sql += 'DELETE VERTEX AP_Order_Line WHERE header = ' + rid + '\n';
    if (id) {
        sql += 'DELETE VERTEX AP_Image WHERE name = \'sign\' AND uuid = \'' + id + '\'\n';
    }
    sql += 'DELETE VERTEX ' + rid + '\n';
    sql += 'COMMIT RETRY 100\n';
    return sql;
}
